// extracted by mini-css-extract-plugin
export var label = "SearchInput-module--label--Cj9JF";
export var text_field = "SearchInput-module--text_field--PX7aB";
export var wrapper = "SearchInput-module--wrapper--9TPFm";